import classNames from "classnames";
import { motion } from "framer-motion";
import PropTypes from "prop-types";

import classes from "./header.module.scss";

function Header({ children, onClick, className, style }) {
  return (
    <motion.div
      className={classNames(classes.header, className)}
      style={style}
      onClick={onClick}
    >
      {children}
    </motion.div>
  );
}

Header.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string.isRequired,
  style: PropTypes.object,
};

Header.defaultProps = {
  className: "",
};

export default Header;
